var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29714 2.44231L10.9587 4.15003M10.3653 0.93788L5.87042 5.55766C5.63816 5.79603 5.47977 6.09973 5.41519 6.43048L5 8.56653L7.07832 8.139C7.40012 8.07285 7.69523 7.91071 7.92755 7.67194L12.4225 3.05215C12.5575 2.91333 12.6647 2.74852 12.7378 2.56714C12.8109 2.38575 12.8485 2.19135 12.8485 1.99502C12.8485 1.79869 12.8109 1.60428 12.7378 1.4229C12.6647 1.24151 12.5575 1.07671 12.4225 0.93788C12.2874 0.799055 12.127 0.688933 11.9506 0.613801C11.7741 0.53867 11.5849 0.5 11.3939 0.5C11.2029 0.5 11.0137 0.53867 10.8372 0.613801C10.6608 0.688933 10.5004 0.799055 10.3653 0.93788Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.83333V12.6333C12.5 13.1284 12.3314 13.6032 12.0314 13.9533C11.7313 14.3033 11.3243 14.5 10.9 14.5H2.1C1.67565 14.5 1.26869 14.3033 0.968629 13.9533C0.668571 13.6032 0.5 13.1284 0.5 12.6333V2.36667C0.5 1.8716 0.668571 1.3968 0.968629 1.04673C1.26869 0.696666 1.67565 0.5 2.1 0.5H4.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBorder);
export default __webpack_public_path__ + "static/media/edit_border.06d4dcb649b1d7386f111856453de35d.svg";
export { ForwardRef as ReactComponent };